module.exports = __webpack_public_path__ + "static/media/live_trading.6c028c5e.PNG";